import { Select as ExoSelect } from "@exopengithub/exokit";
import type { ComponentProps } from "react";
import { useTranslation } from "react-i18next";

// Portal wrapper: injects Swedish default search/no-results/dismiss labels.
export const Select = (props: ComponentProps<typeof ExoSelect>) => {
	const { t } = useTranslation();
	return (
		<ExoSelect
			searchPlaceholder={t("Search")}
			noResultsLabel={t("No results")}
			dismissErrorAriaLabel={t("Dismiss error")}
			{...props}
		/>
	);
};
